export default __webpack_public_path__ + "static/media/product-detail-full-02.2fe27a8b.jpg";